// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2PqGG","alert":"SettungsInbox_alert__31NPY"};